import * as ng from 'angular';
import refs from '../../vendor-modules';
import SecurityModule from '../components/security';
import DataModule from '../data';
import { StandardColumnDirective, StandardGridComponent } from './grid/standard-grid';
import { AddressComponent, IAddressController } from './address';
import { CreditCardComponent, ICreditCardController } from './credit-card';
import { EmailComponent, IEmailController } from './email';
import { FooterComponent, IFooterController } from './footer';
import { HeaderBarComponent, IHeaderBarController } from './header-bar';
import { NavBarComponent, INavBarController } from './nav-bar';
import { ParkingAreaComponent, IParkingAreaController } from './parking-area';
import { ParkingMediaComponent, IParkingMediaController } from './parking-media';
import { PhoneComponent, IPhoneController } from './phone';
import { TitleBarComponent, ITitleBarController } from './title-bar';
import {ReCaptchaComponent} from './recaptcha'

let usercontrolsModule = ng.module("app.userControls", [
    refs.ngRouter,
    refs.ngMaterial,
    refs.ngGetText,
    DataModule.name,
    SecurityModule.name,
    refs.ngUiGrid,
    refs.ngUiGridAutoResize,
    refs.ngUiGridResizeColumns,
    refs.ngUiGridSelection,
    refs.ngUiGridPinning,
    refs.ngUiGridInfiniteScroll,
    refs.vcRecaptcha,
])
    .component(AddressComponent.name, AddressComponent.registration)
    .component(CreditCardComponent.name, CreditCardComponent.registration)
    .component(EmailComponent.name, EmailComponent.registration)
    .component(FooterComponent.name, FooterComponent.registration)
    .component(HeaderBarComponent.name, HeaderBarComponent.registration)
    .component(NavBarComponent.name, NavBarComponent.registration)
    .component(ParkingAreaComponent.name, ParkingAreaComponent.registration)
    .component(ParkingMediaComponent.name, ParkingMediaComponent.registration)
    .component(PhoneComponent.name, PhoneComponent.registration)
    .component(TitleBarComponent.name, TitleBarComponent.registration)
    .directive(StandardColumnDirective.name, StandardColumnDirective.factory)
    .component(StandardGridComponent.name, StandardGridComponent.registration)
    .component(ReCaptchaComponent.name, ReCaptchaComponent.registration);

export {
    //StandardColumn, StandardGrid
    // IAddressController, ICreditCardController, IEmailController, IHeaderBarController,
    // INavBarController, IParkingAreaController, IParkingMediaController, IPhoneController, ITitleBarController
};
export default usercontrolsModule;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/index.ts